export default __webpack_public_path__ + "static/media/book-event-img.35db881a.png";